import styled from "styled-components";

export const NoData = styled.h1`
  color: #000;
  text-align: center;
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  white-space: nowrap;
`;
